<template lang="pug">
div.x-markdown-viewer(
  :style="`height: ${height||30}em; overflow: auto; font-size: 0.9em;`"
)
  vue-markdown.x-markdown-viewer-content(v-bind="$props")
    slot
</template>

<style lang="scss">
.x-markdown-viewer {
  width: 100%;
  overflow-x: auto;

  /*
   * Cores disponiveis para uso no markdown, na forma:
   *   <span class="...">...</span>
   */
  .text-primary { color: var(--v-primary-base); }
  .text-secondary { color: var(--v-secondary-base); }
  .text-accent { color: var(--v-accent-base); }
  .text-success { color: var(--v-success-base); }
  .text-info { color: var(--v-info-base); }
  .text-warning { color: var(--v-warning-base); }
  .text-error { color: var(--v-error-base); }
  .text-dark { color: var(--v-dark-base); }
  .text-light { color: var(--v-light-base); }

  .theme--dark .language-xml code {
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }

  .theme--dark pre.language-xml {
    background-color: #0002 !important;
  }

  .theme--light pre.language-xml {
    background-color: #fff2 !important;
  }

  pre {
    line-height: 1.2em;
    padding: 16px;
    margin-bottom: 16px;
  }

  .language-xml {
    margin: 0 !important;
  }

  /* div.x-markdown-viewer ::-webkit-scrollbar {
    width: 4px !important;
    height: 4px !important;
  } */
}
</style>

<script>
  import VueMarkdown from 'vue-markdown'
  import Prism from 'prismjs'

  // import "prismjs/themes/prism-coy.css";
  // import "prismjs/themes/prism-dark.css";
  // import "prismjs/themes/prism-funky.css";
  // import "prismjs/themes/prism-okaidia.css";
  // import "prismjs/themes/prism-solarizedlight.css";
  // import "prismjs/themes/prism-tomorrow.css";
  // import "prismjs/themes/prism-twilight.css";
  import 'prismjs/themes/prism.css'

  import 'prismjs/components/prism-bash';
  import 'prismjs/components/prism-css';
  import 'prismjs/components/prism-csv';
  import 'prismjs/components/prism-json';
  import 'prismjs/components/prism-markdown';
  import 'prismjs/components/prism-python';
  import 'prismjs/components/prism-regex';
  import 'prismjs/components/prism-sql';
  import 'prismjs/components/prism-typescript';
  import 'prismjs/components/prism-yaml';
  import 'prismjs/components/prism-xml-doc';

  export default {
    components: {
      VueMarkdown
    },

    props: {
      height: Number,

      ...VueMarkdown.props
    },

    mounted() {
      this.highlightAll()
    },

    watch: {
      source: 'highlightAll'
    },

    methods: {
      highlightAll () {
        this.$nextTick(Prism.highlightAll)
      }
    },
  }
</script>
